module.exports = "../images/walleye-caught.jpg?v=7acd7f9";